import React from 'react'
import PropTypes from 'prop-types'

import { FlexColumn, WhiteBGContainer, Divider } from '../styles/Containers'
import { BoldBodyText, Subheading } from '../styles/Text'
import MetricItems from './MetricItems'

function ReportSection({ title, items, groups }) {
  return (
    <WhiteBGContainer padding="15px">
      <FlexColumn gap="15px">
        <BoldBodyText>{title}</BoldBodyText>
        <Divider />
        {items && <MetricItems items={items} />}
        {groups?.map(group => (
          <FlexColumn key={group.heading} gap="8px">
            <Subheading>{group.heading}</Subheading>
            <MetricItems items={group.items} />
          </FlexColumn>
        ))}
      </FlexColumn>
    </WhiteBGContainer>
  )
}

ReportSection.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.string),
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string.isRequired,
      items: PropTypes.arrayOf(PropTypes.string).isRequired
    })
  )
}

export default ReportSection
